import moment from 'moment';
import times from 'lodash/times';
import { DATE_FORMAT } from '../../../CommonComponents/OPL/dates/utils';

const buildHoursOptions = () =>
  times(12).map(val => {
    const value = val + 1;
    return {
      value,
      label: `${value}`.padStart(2, '0'),
    };
  });

const buildMinutesOptions = () =>
  times(60).map(value => ({
    value,
    label: `${value}`.padStart(2, '0'),
  }));

export const hoursOptions = buildHoursOptions();
export const minutesOptions = buildMinutesOptions();
export const getNowHours = () => parseInt(moment().format('h'), 10);
export const getNowMinutes = () => moment().minutes();
export const getNowAmPm = () => moment().format('A') as 'AM' | 'PM';
export const hoursTo24Format = (hours: number, amPm: 'AM' | 'PM') => {
  if (hours === 12) {
    return amPm === 'AM' ? 0 : 12;
  }
  return amPm === 'AM' ? hours : hours + 12;
};

export interface ActivityDateTime {
  date: string;
  hours: number;
  minutes: number;
  amPm: 'AM' | 'PM';
}

export function buildActivityDateIso(state: ActivityDateTime): string {
  if (!state.date) {
    return '';
  }
  const parsed = moment(state.date, DATE_FORMAT, true)
    .hours(hoursTo24Format(state.hours, state.amPm))
    .minutes(state.minutes);
  return parsed.isValid() ? parsed.utc().toISOString() : '';
}
